/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import AppBaseScreen from "../../components/AppBaseScreen";
import { useDispatch } from "react-redux";
import { getPockytBankFormData } from "../../store/actions";
import { Card, CardContent, Container, Link, ThemeProvider, Typography } from "@mui/material";
import { Trans, useTranslation } from "react-i18next";
import { theme } from "./theme";

const VerificationSuccess = () => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    useEffect(() => {
        dispatch(getPockytBankFormData());
    }, [])
    return (
        <AppBaseScreen
            isHeader={false}
            navigate={false}
        >
            <ThemeProvider theme={theme}>
                <Container sx={{ mt: 8, mb: 4, display: 'flex', justifyContent: 'center' }}>
                    <Card>
                        <CardContent>
                            <Typography variant="subtitle2" textAlign={"left"}
                                marginBottom={2}
                                fontWeight={700}
                                sx={{ fontSize: 18 }}>
                                {t('verification.thankyou')}
                            </Typography>
                            <Typography variant="subtitle2" textAlign={"left"} sx={{ fontSize: 14 }}
                                marginBottom={2}
                            >
                                {t('verification.thankyou.caption')}
                            </Typography>

                            <Typography variant="subtitle2"
                                data-i18n={`[html]pockyt.paymentMethodThanksSupport`}
                                textAlign={"left"} sx={{ fontSize: 14 }}>
                                <Trans
                                    components={{
                                        a: (
                                            <Link
                                                href="mailto:support@rocketfuel.inc"
                                                target="_blank"
                                                onClick={() => { }}
                                            />
                                        ),
                                    }}
                                >
                                    {t('pockyt.paymentMethodThanksSupport')}.

                                </Trans>
                            </Typography>
                        </CardContent>
                    </Card>
                </Container>
            </ThemeProvider>
        </AppBaseScreen>
    );
};

export default VerificationSuccess;
